export class Popup {
    constructor(container) {
        this.container = container;
        this.closeButton = container.querySelector(".popup__close");
        this._content = container.querySelector(".popup__content");
        this.closeButton.addEventListener("click", this.close.bind(this));
        this.container.addEventListener("click", this.close.bind(this));
        this.container
            .querySelector(".popup__container")
            .addEventListener("click", (event) => event.stopPropagation());
    }
    set content(value) {
        this._content.replaceChildren(value);
    }
    open() {
        this.container.classList.add("popup_is-opened");
    }
    close() {
        this.container.classList.remove("popup_is-opened");
        this.content = null;
    }
}
